const domain = `${window.__ENV__.PUBLIC_API_URL}/api/v1`; 
const headers = {
    'Accept': "application/json",
    "Content-type": "application/json",
    "Authorization": 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiZnJvbnQtYXBpIiwiaWF0IjoxNzQ1OTkyNDQyfQ.5sgCiS6_MC8p9ry1p_A3XFpKqQaTRlqFeKfmin6Ddtg'
}

window.theme = window.theme || {}

theme.store = {
    get: function(){
        let shop;
        switch (Shopify.shop) {
            case "ontime-checkout-bvv.myshopify.com":
                shop = "ONTIME-CHECKOUT.BVV.KW"
                break;
            case "ontime-kw.myshopify.com":
                shop = "ONTIME.KW"
                break;
            case "ontime-sa.myshopify.com":
                shop = "ONTIME.SA"
                break;
            case "ontime-ae.myshopify.com":
                shop = "ONTIME.AE"
                break;
            
            default:
                break;
        }

        return shop;
    }
}

theme.fetch = {
    request: async(endPoint, method, body = null) => {
        let req, res;
        try {
            if (method == "GET" || method == "DELETE") {
                req = await fetch(`${domain}${endPoint}`,{
                    method: method,
                    headers: headers,
                })
            }else{
                req = await fetch(`${domain}${endPoint}`,{
                    method: method,
                    headers: headers,
                    body: JSON.stringify(body)
                })
            }
            res = await req.json();
        } catch (error) {
            res = error
        }
        return res
    }
}

theme.wishlist = {
    header: {
        setCount: (count)=>{
            document.querySelector("wishlist-header .header__wishlist-count span").innerText = count
            document.querySelector("wishlist-header .header__wishlist-count").setAttribute("data-wishlist-count", count)
        }
    }
}